import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-payrollcheck',
  templateUrl: './payrollcheck.component.html',
  styleUrls: ['./payrollcheck.component.css']
})
export class PayrollcheckComponent implements OnInit {

  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) { }


  //Save Validation
  submitted: boolean;
  successfully: boolean;
  isshowprocess: boolean = false;

  isduplicate: boolean;

  payrollform = new FormGroup({
    payrollgrpid: new FormControl(null, Validators.required),
  });

  payrollgrpColl: any = [];

  periodname: any = "";

  @Output() emitData = new EventEmitter();

  ngOnInit() {

    this.payrollform.reset();
    this.fnInitializeFormGroup();
    this.fngetPayRollGrp();

  }


  fnInitializeFormGroup() {
    this.payrollform.setValue({
      payrollgrpid: null,
    })
  }


  fngetPayRollGrp() {
    var data = {
      'payrollgrpid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getPayrollgrp(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.payrollgrpColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnGeneratePayRoll() {
    this.confirmationDialogService.confirm('Confirm..', 'Do you  want to generate '+this.periodname+' payroll ?')
      .then((confirmed) => {
        if (confirmed) {
          this.fnSaveBtnClick();
        }
      }
      );
  }

  fnSaveBtnClick() {
    try {
      if (this.isshowprocess) {
        return;
      }
      this.submitted = true;
      this.successfully = false;


      //Validate
      if (this.payrollform.valid) {
        this.isshowprocess = true;
        //Check
        var data = {
          companyid: this.loginService.fnGetCompanyId(),
          payrollgrpid: this.payrollform.get('payrollgrpid').value,
          modifiedby: this.loginService.fnGetModUserId()
        }

        this.appService.fnCheckPayrollGenerate(data)
          .subscribe(
            (res) => {
              this.isshowprocess = false;
              if (res.json().status === 200) {



                var result = res.json().result;
                var checkstatus = '';
                var payrollid = 0;


                if (result.length > 0) {
                  checkstatus = result[0][0].checkstatus;
                }

                if (checkstatus === 'DONE') {
                  payrollid = result[1][0].payrollid;
                }



                var popres = {
                  checkstatus: checkstatus,
                  payrollid: payrollid
                }

                this.emitData.emit(popres);
                this.activeModal.close(true);


              }
              else {
                this.loginService.fnAPIError(res.json())
              }
            },
            (err) => {
              this.isshowprocess = false;
              this.toastr.error('Error', err);
            })


      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }




  fnGetPayrollPeriod() {

    this.periodname = "";

    if (!this.payrollform.get('payrollgrpid').value) {
      return
    }
    //Check
    var data = {
      companyid: this.loginService.fnGetCompanyId(),
      payrollgrpid: this.payrollform.get('payrollgrpid').value,
      modifiedby: this.loginService.fnGetModUserId()
    }

    this.appService.fnGetPayrollPeriodDisplay(data)
      .subscribe(
        (res) => {
          this.isshowprocess = false;
          if (res.json().status === 200) {



            var result = res.json().result;
            var checkstatus = '';


            if (result.length > 0) {
              checkstatus = result[0].checkstatus;
            }

            if (checkstatus === 'DONE') {
              this.periodname = result[0].periodname;
            }


          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isshowprocess = false;
          this.toastr.error('Error', err);
        })



  }

  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
